import {
  SET_ALL_BOARDS,
  DELETE_BOARD,
  ADD_NEW_BOARD,
  UPDATE_BOARD,
  SET_SINGLE_BOARD,
} from "../types";
import configVars from "../../config";
import jwt_decode from "jwt-decode";
import { getCookie } from "../../common";

export const getAllBoards = (userJwt) => async (dispatch) => {
  try {
    const response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/getboards/?token=${userJwt}`,
      {
        method: "GET",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
          "Content-Type": "application/json",
        },
      }
    );

    const allBoards = await response.json();
    dispatch({ type: SET_ALL_BOARDS, payload: allBoards.data });
    return { data: allBoards.data };
  } catch (error) {
    console.log({ error });
    return { error: error };
  }
};

export const deleteBoard = (id) => async (dispatch) => {
  const jwtDecoded = getCookie("sustainyou_user_jwt")
    ? jwt_decode(getCookie("sustainyou_user_jwt"))
    : null;
  try {
    const response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/deleteboard`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          board_id: id,
          userid: jwtDecoded.id,
        }),
      }
    );

    dispatch({ type: DELETE_BOARD, payload: id });
    return { data: response.data };
  } catch (error) {
    console.log({ error });
    return { error: error };
  }
};

export const addNewBoard = (data) => async (dispatch) => {
  const jwtDecoded = getCookie("sustainyou_user_jwt")
    ? jwt_decode(getCookie("sustainyou_user_jwt"))
    : null;
  try {
    const response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/createboard`,
      {
        method: "POST",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...data, userid: jwtDecoded.id }),
      }
    );

    const createdBoardResponse = await response.json();

    if (createdBoardResponse.status_code === 200) {
      let board = {
        id: createdBoardResponse?.data?.id,
        title: createdBoardResponse?.data?.title,
        users: createdBoardResponse?.data?.users,
        guide: createdBoardResponse?.data?.guide,
      };

      dispatch({
        type: ADD_NEW_BOARD,
        payload: board,
      });
      return { data: createdBoardResponse };
    }
    return { data: createdBoardResponse };
  } catch (error) {
    console.log({ error });
    return { error: error };
  }
};

export const updateBoard = (data) => async (dispatch) => {
  const jwtDecoded = getCookie("sustainyou_user_jwt")
    ? jwt_decode(getCookie("sustainyou_user_jwt"))
    : null;
  try {
    const response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/createboard`,
      {
        method: "PUT",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...data, userid: jwtDecoded.id }),
      }
    );

    const createdBoardResponse = await response.json();
    let board = {
      id: createdBoardResponse?.data?.id,
      title: createdBoardResponse?.data?.title,
      users: createdBoardResponse?.data?.users,
      guide: createdBoardResponse?.data?.guide,
    };

    if ( createdBoardResponse?.data?.chart ) {
      board.chart = createdBoardResponse?.data?.chart;
    }

    dispatch({
      type: UPDATE_BOARD,
      payload: board,
    });
    localStorage.removeItem(`sy_board_${createdBoardResponse?.data?.id}_guides`);
    return { data: createdBoardResponse };
  } catch (error) {
    console.log({ error });
    return { error: error };
  }
};

export const getBoardById = (id, token, failedCallback) => async (dispatch) => {
  try {
    const response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/getboard/${id}/?token=${token}`,
      {
        method: "GET",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
          "Content-Type": "application/json",
        },
      }
    );

    const singleBoard = await response.json();
    if (singleBoard.status_code === 200) {
      let board = singleBoard?.data;
      dispatch({
        type: SET_SINGLE_BOARD,
        payload: { board, id },
      });
      return { data: board };
    } else {
      failedCallback();
    }
  } catch (error) {
    console.log({ error });
    return { error: error };
  }
};
